import React from 'react';
import FileUpdoadImage from '../../../../../assets/images/file_upload_white.svg';
import DownloadIcon from '../../../../../assets/images/download-white.svg';
import UploadIcon from '../../../../../assets/images/upload-theme.svg';
import CrossIcon from '../../../../../assets/images/close_icn_blue.svg';

import styles from './styles.scss';

const FileCard = ({
  isUpload = false,
  onClick,
  title = 'Button',
  children,
  csx = {},
  isRemove = false,
  onRemoveClick
}) => {
  return (
    <div className={styles.wrapper} style={csx.wrapper || {}}>
      <button
        type="button"
        aria-label="file-upload"
        disabled={isRemove}
        style={csx.root || {}}
        className={styles.root}
        onClick={onClick}
      >
        <div className={styles.container}>
          <div>
            <div className={styles.mainImgWrapper}>
              <img
                src={FileUpdoadImage}
                alt="download-tan-templete"
                style={{ height: '100px' }}
              />
              <div className={styles.imgWrapper}>
                <img
                  src={isUpload ? UploadIcon : DownloadIcon}
                  style={{ height: '15px', width: '15px' }}
                />
              </div>
            </div>
          </div>
          <div className={styles.title}>{title}</div>
        </div>
        <div>{children}</div>
      </button>
      {isRemove && onRemoveClick && (
        <div
          type="button"
          aria-label="Remove"
          className={styles.removeBtnWrapper}
          onClick={onRemoveClick}
        >
          <img src={CrossIcon} height={20} width={20} />
        </div>
      )}
    </div>
  );
};

export default FileCard;
